export default __webpack_public_path__ + "static/media/electronics.7b42bad8.svg";